import React from 'react';

const Footer = () => {
    return (
        <div>
            <p style={{background: '#18181A', padding: '10px'}} className="text-center">razikul.joni69 &copy; 2020 - Present</p>
        </div>
    );
};

export default Footer;